

















import Vue from 'vue'
import {Dictionary} from 'vuex'
import {STUFF_FIELDS_VALS} from '@/constants'
import Org from '@/models/Orgs/Org'
import _ from 'lodash'

export default Vue.extend({
  props: {
    filters: {
      type: Object as () => any,
      default: () => {}
    },
    size: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      test: ''
    }
  },
  methods: {
    getFilterName (filter: string): string {
      return STUFF_FIELDS_VALS[filter] && STUFF_FIELDS_VALS[filter].label || `${this.$t('labels.unknown_filter')} ${filter}`
    },
    getFilterValue (name: string, value: string): string {
      return STUFF_FIELDS_VALS[name] && STUFF_FIELDS_VALS[name].dict && STUFF_FIELDS_VALS[name].dict![value] || value || '';
    },
    isOrgsFilter (name: string): boolean {
      return name === 'orgs'
    },
    getOrgNameById (id: string) {
      const org = this.orgs[id]
      if (org) {
        return org.getName()
      }
      return this.$t('labels.unknown_organization')
    }
  },
  computed: {
    visible (): boolean {
      return !!this.filters && _.isObject(this.filters) && !_.isEmpty(this.filters)
    },
    orgs (): Dictionary<Org> {
      return this.$store.state.orgs.orgs
    }
  },
  async mounted () {
    console.log(this.filters)
    await this.$store.dispatch('orgs/loadList')
  },
})
